import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for LE LIS's "PATCHWORK MINI DRESS" (p_4a23rkzrf2),
// read from that product's own live PDP (faire.com/product/p_4a23rkzrf2)
// "Product reviews" section — not a brand-wide or similar-product fallback
// review.
export const review_ll3: FaireReviewEntity = {
  token: "review_ll3",
  type: "review",
  brandName: "LE LIS",
  brandToken: "b_q8gu9by5sv",
  productToken: "p_4a23rkzrf2",
  reviewType: "product",
  reviewerName: "Dulce",
  reviewerLocation: "Bealeton, VA",
  stars: 5,
  reviewText: "Beautiful beautiful recommend",
  reviewDate: "May 1, 2026",
  meta: {
    source: "api",
    importedAt: "2026-08-11T21:00:27.000Z",
    importedBy: "entity-db-cli",
  },
};
